import { router, usePage } from "@inertiajs/react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select.tsx";

interface FilterOption {
  value: string;
  label: string;
}

interface FilterDropdownProps {
  label: string;
  paramName: string;
  options: FilterOption[];
  allLabel?: string;
  disabled?: boolean;
}

export function FilterDropdown({
  label,
  paramName,
  options,
  allLabel,
  disabled = false,
}: FilterDropdownProps) {
  const { url } = usePage();
  const searchParams = new URLSearchParams(url.split("?")[1] || "");
  const currentValue = searchParams.get(paramName) || "all";

  const handleChange = (value: string) => {
    const params = new URLSearchParams(url.split("?")[1] || "");

    if (value === "all") {
      params.delete(paramName);
    } else {
      params.set(paramName, value);
    }

    params.delete("page");

    router.get(window.location.pathname, Object.fromEntries(params), {
      preserveState: true,
      preserveScroll: true,
    });
  };

  return (
    <Select
      value={currentValue}
      onValueChange={handleChange}
      disabled={disabled}
    >
      <SelectTrigger className="w-auto min-w-[160px]">
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{allLabel ?? `All ${label}`}</SelectItem>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
